let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("coJiW"), load("h4Nf7"), load("6FuHS"), load("eyaRC"), load("lk4cE")]).then(() => parcelRequire('1hgMC'));